/** Имена, которые нельзя оставлять в строке браузера после входа.
 *
 *  Это не то же самое, что список для Sentry (`scrubUrl.ts`): тот заменяет
 *  значения на пометку в тексте события, а здесь адрес переписывается
 *  по-настоящему. Причина одна и та же — адрес утекает дальше, чем кажется:
 *  в историю браузера, в заголовок `Referer` на любой внешний запрос, в
 *  хлебные крошки навигации и в повтор сессии. */
const SECRET_PARAMS = [
  'code',
  'token',
  'token_hash',
  'access_token',
  'refresh_token',
  'provider_token',
  'provider_refresh_token',
  'error_code',
  'error_description',
];

/** Убрать из адреса всё, что оставила ссылка из письма.
 *
 *  Фрагмент срезается ЦЕЛИКОМ, а не разбирается по именам: при
 *  implicit-потоке Supabase кладёт туда `access_token` и `refresh_token`, и
 *  разбор по списку означал бы, что незнакомое имя переживёт чистку. Своих
 *  осмысленных фрагментов у приложения нет — якорей на страницах не бывает.
 *
 *  Возвращает новый адрес или `null`, если чистить нечего: лишний
 *  `replaceState` добавляет запись в историю навигации Sentry на каждом
 *  запуске и мешает читать хлебные крошки настоящих происшествий. */
export function cleanedAuthUrl(href: string): string | null {
  const url = new URL(href);
  const hadHash = url.hash !== '';
  let touched = hadHash;
  url.hash = '';
  for (const name of SECRET_PARAMS) {
    if (url.searchParams.has(name)) {
      url.searchParams.delete(name);
      touched = true;
    }
  }
  return touched ? url.toString() : null;
}

/** То же, но применительно к настоящему адресу вкладки.
 *
 *  `replaceState`, а не `pushState`: кнопка «назад» не должна возвращать
 *  ребёнка на адрес с одноразовым кодом. */
export function cleanAuthUrl(): void {
  const next = cleanedAuthUrl(window.location.href);
  if (next) window.history.replaceState(window.history.state, '', next);
}
